import type { FC } from 'react';
import { useServerContext } from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks';
import { useCustomerGet } from '../../bff-api/customers/useCustomerGet';
import Seo from '../../components/seo';
import { isServer } from '../../utils/utils';
import { configHtmlCache } from '../utils/config-html-cache';

export const InitPWA: FC = () => {
    // make sure the auth is ready.
    useCustomerGet();
    // configure the html cache
    const serverContext = useServerContext();
    if (isServer && serverContext) {
        configHtmlCache(serverContext.res);
    }
    // do not index this page
    return <Seo title="SLT PWA" noIndex />;
};
